import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Ukrainian translations
import commonUa from './locales/ua/common.json';
import homeUa from './locales/ua/home.json';
import accountsUa from './locales/ua/accounts.json';
import sidebarUa from './locales/ua/sidebar.json';
import profileUa from './locales/ua/profile.json';
import incomesUa from './locales/ua/incomes.json';
import referralUa from './locales/ua/referral.json';
import cabinetUa from './locales/ua/cabinet.json';
import reportsUa from './locales/ua/reports.json';
import taxReportsUa from './locales/ua/taxReports.json';
import uploadUa from './locales/ua/upload.json';
import settingsUa from './locales/ua/settings.json';
import checkoutUa from './locales/ua/checkout.json';
import componentsUa from './locales/ua/components.json';
import reportInstructionsUa from './locales/ua/reportInstructions.json';
import unifiedUploadUa from './locales/ua/unifiedUpload.json';
import reportFieldsUa from './locales/ua/reportFields.json';
import syncCommonUa from './locales/ua/syncCommon.json';
import syncUnitsUa from './locales/ua/syncUnits.json';
import syncUnitUa from './locales/ua/syncUnit.json';
import investingAccountUa from './locales/ua/investingAccount.json';
import reportTimelineUa from './locales/ua/reportTimeline.json';
import operationsTimelineUa from './locales/ua/operationsTimeline.json';
import taxPlannerUa from './locales/ua/taxPlanner.json';

// Polish translations
import commonPl from './locales/pl/common.json';
import homePl from './locales/pl/home.json';
import accountsPl from './locales/pl/accounts.json';
import sidebarPl from './locales/pl/sidebar.json';
import profilePl from './locales/pl/profile.json';
import incomesPl from './locales/pl/incomes.json';
import referralPl from './locales/pl/referral.json';
import cabinetPl from './locales/pl/cabinet.json';
import reportsPl from './locales/pl/reports.json';
import taxReportsPl from './locales/pl/taxReports.json';
import uploadPl from './locales/pl/upload.json';
import settingsPl from './locales/pl/settings.json';
import checkoutPl from './locales/pl/checkout.json';
import componentsPl from './locales/pl/components.json';
import reportInstructionsPl from './locales/pl/reportInstructions.json';
import unifiedUploadPl from './locales/pl/unifiedUpload.json';
import reportFieldsPl from './locales/pl/reportFields.json';
import syncCommonPl from './locales/pl/syncCommon.json';
import syncUnitsPl from './locales/pl/syncUnits.json';
import syncUnitPl from './locales/pl/syncUnit.json';
import investingAccountPl from './locales/pl/investingAccount.json';
import reportTimelinePl from './locales/pl/reportTimeline.json';
import operationsTimelinePl from './locales/pl/operationsTimeline.json';
import taxPlannerPl from './locales/pl/taxPlanner.json';
import { env } from '../constants/env-config';

const resources = {
  ua: {
    translation: {
      ...commonUa,
      home: homeUa,
      accounts: accountsUa,
      sidebar: sidebarUa,
      profile: profileUa,
      incomes: incomesUa,
      referral: referralUa,
      cabinet: cabinetUa,
      reports: reportsUa,
      taxReports: taxReportsUa,
      upload: uploadUa,
      settings: settingsUa,
      checkout: checkoutUa,
      components: componentsUa,
      reportInstructions: reportInstructionsUa,
      unifiedUpload: unifiedUploadUa,
      reportFields: reportFieldsUa,
      syncCommon: syncCommonUa,
      syncUnits: syncUnitsUa,
      syncUnit: syncUnitUa,
      investingAccount: investingAccountUa,
      reportTimeline: reportTimelineUa,
      operationsTimeline: operationsTimelineUa,
      taxPlanner: taxPlannerUa,
    },
  },
  pl: {
    translation: {
      ...commonPl,
      home: homePl,
      accounts: accountsPl,
      sidebar: sidebarPl,
      profile: profilePl,
      incomes: incomesPl,
      referral: referralPl,
      cabinet: cabinetPl,
      reports: reportsPl,
      taxReports: taxReportsPl,
      upload: uploadPl,
      settings: settingsPl,
      checkout: checkoutPl,
      components: componentsPl,
      reportInstructions: reportInstructionsPl,
      unifiedUpload: unifiedUploadPl,
      reportFields: reportFieldsPl,
      syncCommon: syncCommonPl,
      syncUnits: syncUnitsPl,
      syncUnit: syncUnitPl,
      investingAccount: investingAccountPl,
      reportTimeline: reportTimelinePl,
      operationsTimeline: operationsTimelinePl,
      taxPlanner: taxPlannerPl,
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: env.LANGUAGE || 'ua',
    fallbackLng: 'ua',
    interpolation: {
      escapeValue: false,
    },
  });

// The app's language code for Ukrainian is 'ua' (not CLDR 'uk'), so Intl.PluralRules('ua') falls back to
// a rule set without few/many. Resolve plural categories for 'ua' with the Ukrainian ('uk') rules; the
// language code itself (resources, settings, locale switches) stays 'ua'.
const PLURAL_RULE_ALIASES = { ua: 'uk' };
const pluralResolver = i18n.services.pluralResolver;
const getRule = pluralResolver.getRule.bind(pluralResolver);
pluralResolver.getRule = (code, options) => getRule(PLURAL_RULE_ALIASES[code] || code, options);

export default i18n;
